<template>
  <div class="BasicDataDetailSetting">
    <el-container>
      <el-header>
        <el-row>
          <el-col :span="24">
            <div class="exportPanel">
              <el-button
                type="primary"
                v-preventReClick
                v-if="btnAuthorize.addOneBtn.btnEnable"
                @click="createFirst(1)"
              >新增一级字典</el-button>
              <el-button
                type="primary"
                v-preventReClick
                v-if="btnAuthorize.addBtn.btnEnable&&sid>0"
                @click="createFirst(2)"
              >新增二级字典</el-button>
              <el-button
                type="primary"
                v-preventReClick
                v-if="btnAuthorize.changeBtn.btnEnable"
                icon="el-icon-edit"
                @click="createFirst(3)"
              >修改</el-button>
              <el-button
                type="primary"
                v-preventReClick
                v-if="btnAuthorize.delBtn.btnEnable"
                 icon="el-icon-delete"
                @click="removeGoodsCate()"
              >删除</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-row style="height:calc(100% - 70px)">
          <el-col :span="8" style="height:100%">
            <div class="tableBox" style="height:100%">
              <el-table
                background
                stripe
                ref="table1"
                :data="firstTableData"
                height="100%"
                size="mini"
                border
                highlight-current-row
                @row-click="firstCurrentChange"
              >
                <el-table-column prop="label" label="字典label" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="value" :label="colName" :show-overflow-tooltip="true"></el-table-column>
              </el-table>
            </div>
          </el-col>
          <el-col :span="8" style="height:100%" v-if="sid>0">
            <div class="tableBox"  style="height:100%">
              <el-table
                background
                stripe
                ref="table2"
                :data="secondTableData"
                height="100%"
                size="mini"
                border
                highlight-current-row
                @row-click="secondCurrentChange"
              >
                <el-table-column prop="label" label="字典label" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="value" :label="secondColName" :show-overflow-tooltip="true"></el-table-column>
              </el-table>
            </div>
          </el-col>
          <el-col :span="8" style="height:100%">
            <div class="tableBox" v-if="classification>=3" style="height:100%">
              <el-table
                background
                stripe
                ref="table3"
                :data="thirdTableData"
                height="100%"
                size="mini"
                border
                highlight-current-row
                @row-click="thirdCurrentChange"
              >
                <el-table-column prop="label" :label="secondTableColum.label" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="value" :label="secondColName" :show-overflow-tooltip="true"></el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <el-dialog
      :title="dialogFormName"
      :visible.sync="isAddDialogShow"
      class="dialog816"
      @close="dialogClose"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        size="mini"
        :model="dialogForm"
        :rules="formRules"
        ref="dialogForm"
        label-width="100px"
      >
        <el-row>
          <el-col :sapn="22">
            <el-form-item label="字典label" prop="label">
              <el-input
                size="small"
                placeholder
                v-model="dialogForm.label"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sapn="22">
            <el-form-item label="字典名称" prop="value">
              <el-input
                size="small"
                type="text"
                placeholder
                v-model="dialogForm.value"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sapn="22">
            <el-form-item label="排序：" prop="sort">
              <el-input
                size="small"
                placeholder
                v-model="dialogForm.sort"
                @input="verifyBillValue('sort')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose()" type="info">取 消</el-button>
        <el-button
          type="primary"
          @click="onSubmit()"
          v-preventReClick
          style=" margin-left:10px;"
        >保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  BasicDataDetailService, //获取数据字典详细列表数据
  BasicDataTwoDetailsService, //获取二级数据字典内容
  insertBasicDataDetailService, //新增数据字典详情列表中的一项数据
  modifyBasicDataDetailService,
  BasicDataDetailsService,    //获取单条数据字典信息
  deleteBasicDataDetailService
} from "../../services/sysSettingService";
export default {
  name: "BasicDataDetailSetting",
  data() {
    return {
      dictId: 0, //字典id
       sid: 0, //是否二级数据字典 默认否
       colName:"字典名称",  //一级字典列名
       secondColName:"字典名称",  //二级字典列名
      firstTableData: [], //一级类目table
      secondTableData: [], //二级类目table
      secondTableColum:{},  //二级table目录
      thirdTableData: [], //三级类目table
      selectFirstTable: [], //选中的一级类目
      selectSecondTable: [], //选中的二级类目
      selectThirdTable: [], //选中的三级类目   选中的类目使用多个分别保存是为了区分操作进行对应的刷新
      selectTable: [], //当前选中的数据
      isAddDialogShow: false,
      dialogForm: {
        dictId: 0,
        label: "",
        sort: 0,
        pid: 0,
        value: ""
      },
      dialogFormName: "新建一级字典",
      dialogCode: 1,
      classification: 1, //新增分类级别     
      formRules: {
        label: [{ required: true, message: "请输入字典标签", trigger: "blur" }],
        // sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          {
            pattern: /(^[0-9]\d*$)/,
            message: "输入内容必须为大于等于0的正整数",
            trigger: "blur"
          }
        ],
        value: [{ required: true, message: "请输入键值", trigger: "blur" }]
      },
      cateTypeCode: 1,
      btnAuthorize: {
        addOneBtn: { btnCode: "2020081116081989024", btnEnable: true },
        addBtn: { btnCode: "2020081116082852592", btnEnable: true },
        changeBtn: { btnCode: "2020081116083849231", btnEnable: true },
        delBtn: { btnCode: "2020081116084532071", btnEnable: true }
      }
    };
  },

  props: {
    menuCode: {
      type: String
    }
  },
  methods: {
    //页面初始加载
    onActive(menuCode) {
      this.sid = this.tabRouteParam ? this.tabRouteParam.sid : 0; //二级数据字典id 如果为0没有二级字典
      this.dictId = this.tabRouteParam.dictId; //字典id
      this.colName=this.tabRouteParam.colName;
      // this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.dialogFormName = "新建一级字典";
      this.secondTableData = [];
      this.thirdTableData = [];
      this.selectFirstTable = [];
      this.selectSecondTable = [];
      this.selectThirdTable = [];
      this.getFirstBasicData();
      if (this.sid > 0) {
        //获取二级字典表目录
        this.$nextTick(() => {
        this.getSecondBasicData();});
      }
    },
    //校验输入规则
    verifyBillValue(key, isIntNum = false) {
      let value = this.dialogForm[key];
      value = value.replace(/[^\d]/g, "");
      //value = value.replace(/^0[^\d]$/g, '');
      this.dialogForm[key] = value;
    },
    //查询二级字典目录
    getSecondBasicData()
    {
       let classification = 1;
      let params = {};
      params.dictId  = this.sid;
      BasicDataDetailsService(params)
        .then(
          res => {
            if (res.code == 10000000) {
              if (classification == 2) {
                this.secondTableColum = res.data;
               
              } else if (classification == 3) {
                this.secondTableColum = res.data;
               
              } else if (classification == 1) {
                // this.secondTableColum = res.data;
                this.secondColName=res.data.name;
              }
            } else {
              this.$alert(res.msg, "提示");
            }
          },
          err => {
            this.$message.error("系统异常");
          }
        )
        .catch(error => {
          this.$message.error("网络请求失败");
        });

    },
    //查询一级字典
    getFirstBasicData() {
      let classification = 1;
      let params = {};
      params.dictId = this.dictId;
      BasicDataDetailService(params)
        .then(
          res => {
            if (res.code == 10000000) {
              if (classification == 2) {
                this.secondTableData = res.data;
                this.selectSecondTable = [];
                this.selectThirdTable = [];
              } else if (classification == 3) {
                this.thirdTableData = res.data;
                this.selectThirdTable = [];
              } else if (classification == 1) {
                this.firstTableData = res.data;
                this.selectFirstTable = [];
                this.selectSecondTable = [];
                this.selectThirdTable = []; //清空三个选中项
              }
            } else {
              this.$alert(res.msg, "提示");
            }
          },
          err => {
            this.$message.error("系统异常");
          }
        )
        .catch(error => {
          this.$message.error("网络请求失败");
        });
    },

    //查询二级数据字典列表
    getFirstBasicData2(code, classification) {
      let params = {};
      // params.dictId = this.dictId;
      params.pid = code;
      BasicDataTwoDetailsService(params)
        .then(
          res => {
            if (res.code == 10000000) {
              if (classification == 2) {
                this.secondTableData = res.data;
                this.selectSecondTable = [];
                this.selectThirdTable = [];
              }
            } else {
              this.$alert(res.msg, "提示");
            }
          },
          err => {
            this.$message.error("系统异常");
          }
        )
        .catch(error => {
          this.$message.error("网络请求失败");
        });
    },
    //选中一级分类
    firstCurrentChange(data) {
      this.thirdTableData = [];
      if (this.sid>0) {
        this.classification = 2;
        this.getFirstBasicData2(data.id, this.classification);
      }

      this.selectFirstTable = data;
      this.selectTable = data;
    },
    //选择二级分类
    secondCurrentChange(data) {
      // this.classification = 3;
      // this.getFirstBasicData(data.cateCode, this.classification);
      this.selectSecondTable = data;
      this.selectTable = data;
    },
    //选中三级分类
    thirdCurrentChange(data) {
      this.selectThirdTable = data;
      this.selectTable = data;
    },
    //操作
    createFirst(code) {
      //用code来判断执行的操作
      this.dialogCode = code;
      if (code == 1) {
        this.dialogFormName = "新建一级字典";
      } else if (code == 2) {
        if (this.selectTable.length == 0) {
          this.$alert("请选中对应操作的数据", "提示", {
            confirmButtonText: "确定"
          });
          return;
        }
        if (this.selectTable.cateLevel == 3) {
          this.$alert("目录最多只有三级", "提示", {
            confirmButtonText: "确定"
          });
          return;
        }
        this.dialogFormName = "新建下级字典";
      } else if (code == 3) {
        if (this.selectTable.length == 0) {
          this.$alert("请选中对应操作的数据", "提示", {
            confirmButtonText: "确定"
          });
          return;
        }
        this.dialogFormName = "修改";
        this.dialogForm.label = this.selectTable.label;
        this.dialogForm.value = this.selectTable.value;
        this.dialogForm.sort = this.selectTable.sort;
        this.dialogForm.dictId = this.selectTable.dictId;
        this.dialogForm.pid = this.selectTable.pid;
        this.dialogForm.id = this.selectTable.id;

        console.log(this.dialogForm);
        console.log(this.dialogForm);
        console.log(this.dialogForm);
      }
      this.isAddDialogShow = true;
    },
    //新建一级分类
    dialogClose() {
      for (let key in this.dialogForm) {
        if (key != "user") {
          this.dialogForm[key] = "";
        }
      }
      this.$refs.dialogForm.resetFields();
      this.isAddDialogShow = false;
      console.log(this.dialogForm);
    },
    //新建一级分类
    onSubmit() {
      if (this.dialogCode == 1) {
        this.addDatasCate(1);
      } else if (this.dialogCode == 3) {
        this.modifyGoodsCate();
      } else if (this.dialogCode == 2) {
        this.addDatasCate(2);
      }
    },
    //新增
    addDatasCate(code) {
      this.$refs["dialogForm"].validate(valid => {
        if (valid) {
          let params = {
            dictId: this.dictId,
            // pid:this.dialogForm.pid,
            label: this.dialogForm.label,
            sort: parseInt(this.dialogForm.sort),
            value: this.dialogForm.value
          };
          if (code == 1) {
            params.pid = 0;
          } else if(code == 2){
             params.dictId = this.sid;
             params.pid = this.selectTable.id;
            }else {
            params.pid = this.selectTable.id;
          }
          // params.cateTypeCode = this.cateTypeCode;
          // if (this.selectTable.cateLevel == 1) {
          // } else if (this.selectTable.cateLevel == 2) {
          // }
          let paramstr = [];
          paramstr.push(params);
          insertBasicDataDetailService(paramstr).then(res => {
            console.log(res);
            if (res.code == 10000000) {
              this.$alert("操作成功", "提示", {
                confirmButtonText: "确定"
              });

              this.$refs.dialogForm.resetFields();
              this.isAddDialogShow = false;
              if (code == 1) {
                this.secondTableData = [];
                this.thirdTableData = [];
                this.getFirstBasicData();
                this.selectTable = [];
              } else {
                this.thirdTableData = [];
                this.getFirstBasicData2(this.selectFirstTable.id, 2);
                this.selectTable = this.selectFirstTable;
              }
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //修改
    modifyGoodsCate() {
      this.$refs["dialogForm"].validate(valid => {
        if (valid) {
          let params = {
            id: this.dialogForm.id,
            pid: this.dialogForm.pid,
            dictId: this.dialogForm.dictId,
            label: this.dialogForm.label,
            sort: this.dialogForm.sort,
            value: this.dialogForm.value
          };
          modifyBasicDataDetailService(params).then(res => {
            console.log(res);
            if (res.code == 10000000) {
              this.$alert("操作成功", "提示", {
                confirmButtonText: "确定"
              });
              this.$refs.dialogForm.resetFields();
              this.isAddDialogShow = false;
              if (this.selectTable.pid == 0) {
                this.secondTableData = [];
                this.thirdTableData = [];
                this.getFirstBasicData();
                this.selectTable = [];
              } else if (this.selectTable.pid > 0) {
                this.thirdTableData = [];
                this.getFirstBasicData2(this.selectFirstTable.id, 2);
                this.selectTable = this.selectFirstTable;
              } else {
                this.getFirstBasicData(this.selectSecondTable.id, 3);
                this.selectTable = this.selectSecondTable;
              }
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    //删除分类
    removeGoodsCate() {
      if (this.selectTable.length == 0) {
        this.$alert("请选中对应操作的数据", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      this.$confirm("确认进行删除操作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          dictIdSet: this.selectTable.id
        }; //回传数据
        //let cateLevel = ""; //判断删除的类目级别
        // if (this.selectThirdTable) {
        //   params.cateCode = this.selectThirdTable.cateCode;
        //   cateLevel = this.selectThirdTable.cateLevel;
        // } else if (this.selectSecondTable) {
        //   params.cateCode = this.selectSecondTable.cateCode;
        //   cateLevel = this.selectSecondTable.cateLevel;
        // } else {
        //   params.cateCode = this.selectFirstTable.cateCode;
        //   cateLevel = this.selectFirstTable.cateLevel;
        // }
        deleteBasicDataDetailService(params).then(res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("操作成功", "提示", {
              confirmButtonText: "确定"
            });
            if (this.selectTable.pid == 0) {
              this.secondTableData = [];
              this.thirdTableData = [];
              this.getFirstBasicData();
              this.selectTable = [];
            } else if (this.selectTable.pid > 0) {
              this.thirdTableData = [];
              this.getFirstBasicData2(this.selectFirstTable.id, 2);
              this.selectTable = this.selectFirstTable;
            } else {
              this.getFirstBasicData(this.selectSecondTable.cateCode, 3);
              this.selectTable = this.selectSecondTable;
            }
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
          err => {
            this.$message.error("系统异常");
          };
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.BasicDataDetailSetting {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #fff;
  flex-direction: column;
}
/deep/.el-form-item__label {
  text-align: right;
}
.el-footer {
  text-align: right;
}
/deep/.el-col {
  text-align: left;;
  padding-top: 20px;
}
/deep/.el-dialog {
  .el-select {
    width: 100%;
  }
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>